import React from "react";
import { Button, dialog } from "nq-component";
import Table from "../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import { InfiniteScroll } from "nq-component";
import withRouter from "../../../withRouter";
import BaseListPage from "../../../base/BaseListPage";
import CardView from "../../../components/common/CardView";
import EmployeePresenter from "./EmployeesPresenter";
import ScheduleAssignTable from "./assign-to-employee/ScheduleAssignTable";
import SearchSelect from "../../../components/searchSelect/SearchSelect";
import AllowanceAssignTable from "./assign-to-employee/AllowanceAssignTable";
import ContributionAssignTable from "./assign-to-employee/ContributionAssignTable";
import StepIncrement from "./employeeComponent/StepIncrement";
import SeparateEmployee from "./employeeComponent/SparateEmployee";
import LeaveCard from "./employeeComponent/LeaveCard";
import {
  DialogConfirmation,
  FloatingForm,
} from "../../../components/common/Converter";
import HRAction from "./employeeComponent/HRAction";
import Suspension from "./employeeComponent/Suspension";
import InputFactory from "../../../components/InputFactory";
import Progress from "../../../components/Progress";
import { Spin } from "antd";

class EmployeePage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new EmployeePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
    );
    this.state = {
      selected: [],
      objects: [],
      assignTable: "Schedule",
      employeeName: "",
      assignSchedule: "",
      hrAction: false,
      hrActionData: {},
      stepIncrement: false,
      stepIncrementData: [],
      separateEmployee: false,
      generateLeaveCard: false,
      count: 0,
      limit: 50,
      current: 1,
      isScheduler: false,
    };
    this.contractPDF = React.createRef();
  }

  getCollectionName() {
    return "employees";
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    const roles = this.getCurrentRoles();
    const isScheduler = roles.some((item) => item.id === "Scheduler");
    this.setState({ isScheduler });
    // const assignTable = sessionStorage.getItem("assignTable");
    // this.setState({ assignTable });
  }

  // delete function
  async handleDeleteData(obj) {
    DialogConfirmation(obj.id, this.getCollectionName(), () =>
      this.refetchData(),
    );
  }

  // edit function
  async handleEditData(id) {
    const user = this.getCurrentUser();
    const date = new Date();

    console.log("date", date);
    const formattedDate = date.toLocaleString("en-US", {
      month: "long", // Full month name
      day: "numeric", // Day of the month
      year: "numeric", // Full year
      hour: "2-digit", // Hour in 12-hour format
      minute: "2-digit", // Minute
      second: "2-digit", // Second
      hour12: true, // Use 12-hour format with AM/PM
    });
    const logData = {
      logDate: formattedDate.toString(),
      user: user.email,
      activity: "Clicked Edit Employee",
      message: `${user.email} Click Edit Button on Employees module`,
    };
    try {
      await upsertUseCase().execute("audit_logs", logData);
    } catch (e) {
      console.error("Error: ", e);
    }
    this.navigateTo(`/form/${this.getCollectionName()}/${id}`);
    this.refetchData();
  }

  async handleViewObject(data) {
    const user = this.getCurrentUser();
    const date = new Date();
    const formattedDate = date.toLocaleString("en-US", {
      month: "long", // Full month name
      day: "numeric", // Day of the month
      year: "numeric", // Full year
      hour: "2-digit", // Hour in 12-hour format
      minute: "2-digit", // Minute
      second: "2-digit", // Second
      hour12: true, // Use 12-hour format with AM/PM
    });
    const logData = {
      logDate: formattedDate.toString(),
      user: user.email,
      activity: "Clicked View Employee",
      message: `${user.email} Click View Button on Employees module`,
    };
    try {
      await upsertUseCase().execute("audit_logs", logData);
    } catch (e) {
      console.error("Error: ", e);
    }
    this.navigateTo(`/profile/${data.id}`);
  }

  async handleAction(action, data) {
    // console.log("HRR :", data);

    const startOfYear = new Date(`${2025}-01-01T00:00:00.000Z`);
    const endOfYear = new Date(`${2025}-12-31T23:59:59.999Z`);

    const leaveCard = await findObjectUseCase().execute("leave_card", {
      where: {
        "employee.id": data?.id,
        createdAt: {
          $gte: startOfYear,
          $lte: endOfYear,
        },
      },
    });

    this.setState({ [action]: true, [action + "Data"]: data, leaveCard });

    // printComponent(this.contractPDF.current, "Tasks");
  }
  closeAction(action) {
    this.setState({ [action]: false });
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  handleAddEmployee() {
    this.navigateTo(`/form/${this.getCollectionName()}`);
  }

  handleScheduleChange(assignTable) {
    this.setState({ assignTable });
    // sessionStorage.setItem("assignTable", assignTable);
  }

  async confirmChanges() {
    this.submitting();
    try {
      if (this.state.assignSchedule !== "") {
        this.state.selected.forEach(async (item) => {
          const { id, ...assignSchedule } = this.state.assignSchedule;
          const object = {
            id: item.id,
            selectedSchedule: { id: id },
            selected_schedule_assignment: {
              employeeId: item.id,
              ...assignSchedule,
            },
          };
          await upsertUseCase().execute("employees", object);
        });
        this.refetchData();
      }
      if (this.state.allowanceData && this.state.allowanceData.length > 0) {
        this.state.selected.forEach(async (emp) => {
          console.log("emp: ", emp);
          this.state.allowanceData.forEach(async (allowance) => {
            const allowanceObj = {
              empID: emp.id,
              allowance: allowance.allowance,
              amount: allowance.amount,
              taxable: allowance.taxable,
              isAmount: allowance.isAmount,
              isMonthlyRate: allowance.isMonthlyRate,
              excessAmount: allowance.excessAmount,
            };

            if (allowance.isMonthlyRate) {
              if (
                emp.employmentType &&
                emp.employmentType.types === "Non-Plantilla"
              ) {
                allowanceObj.amount = Number(
                  emp?.nonRegPosition?.montlhyRate?.replace(/[^0-9.-]+/g, "") ||
                    0,
                );
              } else {
                allowanceObj.amount = Number(
                  emp?.position?.salaryPointer["Monthly Rate"]?.replace(
                    /[^0-9.-]+/g,
                    "",
                  ) || 0,
                );
              }
            }
            // console.log("allowance: ", allowanceObj);
            await upsertUseCase().execute("allowances", allowanceObj);
          });
        });
      }
      if (
        this.state.contributionData &&
        this.state.contributionData.length > 0
      ) {
        this.state.selected.forEach(async (emp) => {
          this.state.contributionData.forEach(async (contribution) => {
            const contributionObj = {
              empID: emp.id,
              contribution: contribution.contribution,
              amount: contribution.amount,
              startdate: contribution.startdate,
            };
            await upsertUseCase().execute("contributions", contributionObj);
          });
        });
      }

      dialog.close();
      this.setState({ assignedToEmp: false, selected: [] });
      this.showSuccess("Assigned schedules to selected employees.");
    } catch (e) {
      console.error(e.message || e);
      this.submissionError();
    } finally {
      this.submissionSuccess();
    }
  }

  handleClickOk() {
    if (this.state.submitting) return;

    dialog.fire({
      html: (
        <div className="pt-4 pe-4 ps-4">
          <div className="row">
            <div className="col-lg-1">
              <i
                className="bi bi-question-circle"
                style={{
                  zoom: 2,
                  color: "#faad14",
                }}
              />
            </div>
            <div className="col-lg-11">
              {" "}
              <p className="fw-bold">
                You are about to save changes for the selected employee(s).
              </p>
            </div>
          </div>
          <p style={{ color: "rgba(0, 0, 0, .65)" }}>
            Please click on OK to confirm changes.
          </p>

          <div className="w-100 d-flex justify-content-end gap-4 m-4 pe-3">
            <Button
              className="btn btn-light fs-sm"
              onClick={() => dialog.close()}
            >
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              progress={this.state.submitting}
              disabled={this.state.submitting}
              onClick={() => {
                dialog.close();
                this.confirmChanges();
              }}
            >
              OK
            </Button>
          </div>
        </div>
      ),
      footer: false,
    });
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, isScheduler, loading, selected, count, current, limit } =
      this.state;

    // console.log("isScheduler: ", selected);

    const isMobile = window.innerWidth <= 768;
    const scheduleTemplate =
      // ["Schedule"];
      isScheduler ? ["Schedule"] : ["Schedule", "Allowance", "Contributions"];
    schema.fields = {
      ...schema.fields,
      positionLabel: { type: "String", label: "Position" },
    };
    const includeLabel = Object.keys(schema.fields).filter(
      (fields) =>
        fields !== "agency" &&
        fields !== "Firstname" &&
        fields !== "Middlename" &&
        fields !== "surname" &&
        fields !== "email" &&
        fields !== "positionLabel" &&
        fields !== "hired",
    );
    if (!schema) return <Progress />;

    const removeActions = this.getCurrentRoles().some((item) =>
      ["cebs", "event logs", "checker", "cebs - lds"].includes(
        item?.id?.toLowerCase(),
      ),
    );
    const removeAssignedUser = this.getCurrentRoles().some((item) =>
      ["supervisor"].includes(item?.id?.toLowerCase()),
    );

    return (
      <>
        <div className="overflow-auto" style={{ marginTop: "5rem" }}>
          {/* <div className="d-none2">
            <div ref={this.contractPDF} id="contractPDF">
              <GenerateLeaveCard
                object={this.state.generateLeaveCardData}
                leaveRequest={this.state.leaveCard}
                yearSelected={"2025"}
              />
            </div>
          </div> */}
          <InfiniteScroll className="h-100" loadMore={this.loadMore.bind(this)}>
            <div className="p-3 p-lg-4">
              <div
                className="d-flex mb-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  You are here: Home {">"} Human Resource {">"}{" "}
                  <span
                    style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                  >
                    {schema.collection}
                  </span>
                </p>
              </div>
              <CardView style={{ borderRadius: 0 }}>
                <div className="row p-1">
                  {Object.keys(schema.filters || {})
                    .filter(
                      (field) =>
                        ![
                          "earnings",
                          "sex",
                          "civil",
                          "month",
                          "year",
                          "lengthOfService",
                          "employmentType",
                        ].includes(field),
                    )
                    .map((field) => {
                      let { type, ...options } = schema.filters[field];
                      return (
                        <div className="col-lg-4 p-1" key={field}>
                          <InputFactory
                            key={field}
                            type={type}
                            field={field}
                            where={{}}
                            onChange={this.onChangeFilter.bind(this, type)}
                            {...options}
                          />
                        </div>
                      );
                    })}
                </div>
              </CardView>

              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center justify-content-center">
                    <h4 className="text-primary">{schema.label}</h4>
                    <div style={{ marginLeft: "auto" }}>
                      {!removeAssignedUser && (
                        <>
                          <Button
                            disabled={this.state.selected.length <= 0}
                            onClick={() => {
                              this.setState({ assignedToEmp: true });
                            }}
                            style={{
                              marginRight: "10px",
                              backgroundColor: "#29457c",
                              border: "none",
                            }}
                          >
                            Assign to Employees
                          </Button>
                          {!isScheduler && (
                            <Button
                              style={{
                                backgroundColor: "#29457c",
                                border: "none",
                              }}
                              onClick={this.handleAddEmployee.bind(this)}
                            >
                              <i className="bi bi-plus-lg" /> New{" "}
                              {schema.collection}
                            </Button>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </CardView>
              </div>

              <Table
                // objectId={this.handleDeleteData.bind(this)}
                currectRoles={isScheduler}
                editId={this.handleEditData.bind(this)}
                viewObject={this.handleViewObject.bind(this)}
                viewPayroll={this.handleDeleteData.bind(this)}
                objectData={(data) => {
                  this.handleAction("viewSchedule", data);
                }}
                hrAction={(data) => {
                  this.handleAction("hrAction", data);
                }}
                stepIncrement={(data) => {
                  this.handleAction("stepIncrement", data);
                }}
                separateEmployee={(data) => {
                  this.handleAction("separateEmployee", data);
                }}
                generateLeaveCard={(data) => {
                  this.handleAction("generateLeaveCard", data);
                }}
                ofTraining={(data) => {
                  this.handleAction("suspension", data);
                }}
                ofAppearance={(data) => this.presenter.handleUnSuspension(data)}
                progress={loading}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={
                  removeActions
                    ? []
                    : isScheduler || removeAssignedUser
                      ? [
                          {
                            label: <i className="bi bi-search"> Schedule</i>,
                            actionType: "object",
                          },
                        ]
                      : [
                          {
                            label: <i className="bi bi-three-dots-vertical" />,
                            actionType: "Employees List",
                          },
                        ]
                }
                selectable
                // collapsable
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["id", "Created At", "Updated At", ...includeLabel],
                )}
                selected={selected}
                onSelect={(value) => this.presenter.onSelect(value)}
                onSelectAll={this.onSelectAll.bind(this)}
                // progress={progress}
                // onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
        {this.state.hrAction && (
          <HRAction
            object={this.state.hrActionData}
            refetchData={() => this.refetchData()}
            closeHR={() => {
              this.closeAction("hrAction");
            }}
          />
        )}
        {this.state.stepIncrement && (
          <StepIncrement
            object={this.state.stepIncrementData}
            refetchData={() => this.refetchData()}
            closeStepIncrement={() => {
              this.closeAction("stepIncrement");
            }}
          />
        )}
        {this.state.separateEmployee && (
          <SeparateEmployee
            closeSeparateEmployee={() => {
              this.closeAction("separateEmployee");
            }}
            data={this.state.separateEmployeeData}
          />
        )}
        {this.state.generateLeaveCard && (
          <LeaveCard
            object={this.state.generateLeaveCardData}
            leaveRequest={this.state.leaveCard}
            closeGenerateLeaveCard={() => {
              this.closeAction("generateLeaveCard");
            }}
          />
        )}

        {this.state.suspension && (
          <Suspension
            object={this.state.suspensionData}
            refetchData={() => this.refetchData()}
            closeSeparation={() => {
              this.closeAction("suspension");
            }}
          />
        )}

        {/* assign to employee  */}
        {this.state.assignedToEmp && (
          <FloatingForm width="80%">
            <CardView style={{ padding: 0 }}>
              <h4
                className="fs-6 fw-bold"
                style={{ padding: "0 1rem", paddingTop: "1rem" }}
              >
                Assign to Employee(s)
              </h4>
              <hr />
              <div style={{ padding: "0 1rem" }}>
                <span style={{ fontWeight: "bold", fontSize: "15px" }}>
                  Assign to:
                </span>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                  }}
                >
                  {this.state.selected.map((data, index) => {
                    return (
                      <div
                        key={index}
                        className={`${isMobile ? "w-50" : "w-25"} mb-2`}
                      >
                        <span style={{ fontSize: "15px" }}>
                          {data.surname}
                          {","} {data.Firstname} {data.Middlename}
                        </span>
                      </div>
                    );
                  })}
                </div>

                <div className="col-lg-3 mt-4" style={{}}>
                  <SearchSelect
                    value={this.state.assignTable}
                    onChange={this.handleScheduleChange.bind(this)}
                    onClickClear={() => this.handleScheduleChange("")}
                    options={scheduleTemplate.map((sched) => ({
                      label: sched,
                      value: sched,
                    }))}
                  />
                </div>

                <div
                  style={{
                    border:
                      this.state.assignTable !== "" &&
                      this.state.assignTable !== null &&
                      "1px solid #d3d3d3",
                    marginBottom: "2rem",
                  }}
                >
                  {this.state.assignTable === "Schedule" && (
                    <ScheduleAssignTable
                      assignSchedule={(assignSchedule) =>
                        this.setState({ assignSchedule })
                      }
                      isScheduler={isScheduler}
                      currentUser={this.getCurrentUser()}
                    />
                  )}
                  {this.state.assignTable === "Allowance" && (
                    <AllowanceAssignTable
                      selected={this.state.selected}
                      allowanceData={(data) =>
                        this.setState({ allowanceData: data })
                      }
                    />
                  )}
                  {this.state.assignTable === "Contributions" && (
                    <ContributionAssignTable
                      selected={this.state.selected}
                      contributionData={(data) => {
                        this.setState({ contributionData: data });
                      }}
                    />
                  )}
                </div>
              </div>
              <hr />
              <div className="w-100 d-flex justify-content-end gap-4 mb-3 pe-3">
                <Button
                  className="btn btn-light fs-sm"
                  onClick={() => this.setState({ assignedToEmp: false })}
                >
                  Cancel
                </Button>
                <Button
                  className="btn btn-primary"
                  progress={this.state.submitting}
                  disabled={this.state.submitting}
                  onClick={this.handleClickOk.bind(this)}
                >
                  OK
                </Button>
              </div>
            </CardView>
          </FloatingForm>
        )}
        {this.state.submitting && (
          <FloatingForm width={"30rem"}>
            <CardView>
              <div className="d-grid align-items-center justify-content-center p-5">
                <Spin size="large" />
                <span>Loading...</span>
              </div>
            </CardView>
          </FloatingForm>
        )}
        {this.state.viewSchedule && (
          <FloatingForm width="80%">
            <CardView style={{ padding: 0 }}>
              <ScheduleAssignTable
                assignSchedule={(assignSchedule) =>
                  this.setState({ assignSchedule })
                }
                isScheduler={isScheduler}
                currentUser={this.getCurrentUser()}
                scheduleObj={
                  this.state.viewScheduleData?.selectedSchedule || {}
                }
                isForView={true}
              />
              <hr />
              <div className="w-100 d-flex justify-content-end gap-4 mb-3 pe-3">
                <Button
                  className="btn btn-light fs-sm"
                  onClick={() => this.setState({ viewSchedule: false })}
                >
                  Close
                </Button>
              </div>
            </CardView>
          </FloatingForm>
        )}
      </>
    );
  }
}

export default withRouter(EmployeePage);
